import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/utils";
import { useAuth } from "@/lib/auth";
import { canSendPacks } from "@/lib/permissions";

type Issuance = {
  id: string;
  recipientName: string;
  recipientEmail: string;
  recipientCompany: string | null;
  createdAt: string;
  firstOpenedAt: string | null;
  completedAt: string | null;
  expiryDate: string;
};

export function IssuancesPage() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["issuances"],
    queryFn: () => api.get<{ items: Issuance[] }>("/api/admin/issuances"),
  });
  return (
    <div className="space-y-4 max-w-6xl">
      <div className="flex items-center justify-between">
        <h1 className="font-head text-2xl font-semibold">Demo Packs</h1>
        {canSendPacks(user?.role) && (
          <Link to="/admin/issuances/new"><Button>Compose pack</Button></Link>
        )}
      </div>
      <Card>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b border-admin-rule">
              <th className="p-3 font-medium">Recipient</th>
              <th className="p-3 font-medium">Company</th>
              <th className="p-3 font-medium">Status</th>
              <th className="p-3 font-medium">Sent</th>
              <th className="p-3 font-medium">Expires</th>
            </tr>
          </thead>
          <tbody>
            {data?.items.map((i) => (
              <tr key={i.id} className="border-b border-admin-rule">
                <td className="p-3">
                  <Link to={`/admin/issuances/${i.id}`} className="font-medium hover:text-gold">{i.recipientName}</Link>
                  <div className="text-xs text-muted-foreground">{i.recipientEmail}</div>
                </td>
                <td className="p-3">{i.recipientCompany ?? "—"}</td>
                <td className="p-3">
                  <Badge variant={i.completedAt ? "ok" : i.firstOpenedAt ? "electric" : "muted"}>
                    {i.completedAt ? "Completed" : i.firstOpenedAt ? "Opened" : "Unopened"}
                  </Badge>
                </td>
                <td className="p-3 text-xs">{formatDateTime(i.createdAt)}</td>
                <td className="p-3 text-xs">{formatDateTime(i.expiryDate)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
